import useSWR from 'swr'

import { EndUser } from '@driftt/api-types'

import { InboxAPI } from 'api/index'
import useDebounce from 'hooks/useDebounce'

export const fetchEndUsers = async (
  url,
  queryParams = ''
): Promise<EndUser[]> => {
  if (!queryParams) return []
  const res = await InboxAPI.get<EndUser[]>(`${url}?${queryParams}`)
  return res.data
}

export const useEndUsers = (endUserIds: string[]) => {
  const debouncedEndUserIds = useDebounce(endUserIds, 750)
  const queryParams = debouncedEndUserIds.map((id) => `endUser=${id}`).join('&')

  return useSWR(['/data/endusers', queryParams], fetchEndUsers, {
    revalidateOnFocus: false,
    refreshInterval: 0,
    dedupingInterval: 60000,
  })
}
